import { useState, useEffect } from "react";
import "./PrivacySettings.css";

import {
  MdVisibility,
  MdPhone,
  MdEmail,
  MdLocationOn,
  MdAccessTime,
  MdStar,
  MdReviews,
  MdDeliveryDining,
  MdStore,
  MdSave,
} from "react-icons/md";

import {
  getPrivacySettings,
  updatePrivacySettings,
} from "../../services/providerSettingsService";
function PrivacySettings() {
  const [settings, setSettings] = useState({
    showPhone: true,
    showEmail: false,
    showAddress: true,

    showBusinessHours: true,
    showRatings: true,
    showReviewCount: true,
    showAverageDeliveryTime: true,

    showBusinessWhenClosed: false,
    showExactLocation: false,
    allowDirectCalling: true,
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchPrivacySettings();
  }, []);

  const fetchPrivacySettings = async () => {
    try {
      const res = await getPrivacySettings();

      if (res.success && res.privacySettings) {
        setSettings(res.privacySettings);
      }
    } catch (error) {
      console.error("Error loading privacy settings:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (field) => {
    setSettings((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      const res = await updatePrivacySettings(settings);

      if (res.success) {
        alert("Privacy settings updated successfully.");
      }
    } catch (error) {
      console.error("Error saving settings:", error);
      alert("Failed to save privacy settings.");
    } finally {
      setSaving(false);
    }
  };

  const Toggle = ({ label, field, icon }) => (
    <div className="setting-row">
      <div className="setting-left">
        <div className="setting-icon">{icon}</div>

        <div>
          <h4>{label}</h4>
        </div>
      </div>

      <label className="switch">
        <input
          type="checkbox"
          checked={settings[field]}
          onChange={() => handleToggle(field)}
        />
        <span className="slider"></span>
      </label>
    </div>
  );

  if (loading) {
    return (
      <div className="privacy-settings-page">
        <h2>Loading Privacy Settings...</h2>
      </div>
    );
  }

  return (
    <div className="privacy-settings-page">
      <div className="settings-header">
        <div>
          <h1>Privacy & Visibility</h1>
          <p>Control what customers can see about your business.</p>
        </div>
      </div>

      {/* Contact Information */}
      <div className="settings-card">
        <h2>Contact Information</h2>

        <Toggle
          label="Show Phone Number"
          field="showPhone"
          icon={<MdPhone />}
        />

        <Toggle
          label="Show Email Address"
          field="showEmail"
          icon={<MdEmail />}
        />

        <Toggle
          label="Show Business Address"
          field="showAddress"
          icon={<MdLocationOn />}
        />
      </div>

      {/* Business Information */}
      <div className="settings-card">
        <h2>Business Information</h2>

        <Toggle
          label="Show Business Hours"
          field="showBusinessHours"
          icon={<MdAccessTime />}
        />

        <Toggle
          label="Show Ratings"
          field="showRatings"
          icon={<MdStar />}
        />

        <Toggle
          label="Show Review Count"
          field="showReviewCount"
          icon={<MdReviews />}
        />

        <Toggle
          label="Show Average Delivery Time"
          field="showAverageDeliveryTime"
          icon={<MdDeliveryDining />}
        />
      </div>

      {/* Business Visibility */}
      <div className="settings-card">
        <h2>Business Visibility</h2>

        <Toggle
          label="Show Business Even When Closed"
          field="showBusinessWhenClosed"
          icon={<MdStore />}
        />

        <Toggle
          label="Show Exact Business Location"
          field="showExactLocation"
          icon={<MdVisibility />}
        />

        <Toggle
          label="Allow Customers To Call Directly"
          field="allowDirectCalling"
          icon={<MdPhone />}
        />
      </div>

      {/* Footer */}
      <div className="settings-footer">
        <button
          className="save-settings-btn"
          onClick={handleSave}
          disabled={saving}
        >
          <MdSave />
          {saving ? "Saving..." : "Save Privacy Settings"}
        </button>
      </div>
    </div>
  );
}

export default PrivacySettings;